import React from 'react';
import { Component } from 'puzzle';
import { STATE, PROPS } from "./Types"
import { QUOTE_COMMENT } from "../Types"
import uuid from "uuid-random";

class QuoteComments extends Component<PROPS, STATE> {
  render() {
    const { comments, userName } = this.props
    return (
      <div className={'tp-quote-comments-wrap'} tabIndex={0} aria-label={this.translate('commentsSection')}>
        {comments.map((comm: QUOTE_COMMENT, index: number) => {
          const time = this.translateByNamespace('date.dateWithTime', { date: new Date(comm.date) })
          return (
            <React.Fragment key={uuid()}>
              <div className={`tp-quote-comment-info client ${comm.userName === userName ? 'me' : ''} tp-text-semibold`}
                   key={index + '_' + uuid()} data-author={comm.userName}>
                {comm.userName} {this.translate('wrote_on')} <span><time dateTime={time}>{time}</time></span>
              </div>
              <div className={`tp-quote-comment client ${comm.userName === userName ? 'me' : ''}`}
                   key={index + '_' + uuid()} data-author={comm.userName}>
                <div className={'tp-quote-comment-msg'} dangerouslySetInnerHTML={{ __html: comm.comment }}>
                </div>
              </div>
            </React.Fragment>
          )
        })}
      </div>
    );
  }
}

export default QuoteComments
